import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import * as utils from "common/utils";
import Panel from "components/Panel/Panel";
import PanelBody from "components/Panel/PanelBody";
import ActionLink from "components/ActionLink";
import { getMyUserInvitations, getMyFarmAccessInvitations, getMyFarmAccessRequests, resendFarmAccessRequest, getMyFarmGroups } from "./_actions";
import { confirm } from "containers/App/_actions";
import { useModal } from "common/effects";
import FarmGroupInvitationResponseModal from "containers/FarmGroups/FarmGroupInvitationResponseModal";
import FarmAccessRequestResponseModal from "./Modals/FarmAccessRequestResponseModal";
import FarmOwnershipNominationResponseModal from "./Modals/FarmOwnershipNominationResponseModal";
import OrgInvitationResposneModal from "./Modals/OrgInvitationResposneModal";
import Page from "components/Page";
import PageBody from "components/PageBody";
import DashboardPageHead from "./DashboardPageHead";

const MyNotificationActions = (props) => {
    const { authContext, online, loading, myActions, getMyUserInvitations, getMyFarmAccessInvitations, getMyFarmAccessRequests, getMyFarmGroups } = props;
    const { openModal, getModal } = useModal();

    React.useEffect(() => {
        getMyUserInvitations();
        getMyFarmAccessInvitations();
        getMyFarmAccessRequests();
        getMyFarmGroups();
    }, [online, getMyUserInvitations, getMyFarmAccessInvitations, getMyFarmAccessRequests, getMyFarmGroups]);

    const thereAreNoActions = myActions.actionCount === 0;
    if (thereAreNoActions) return null;

    const respondToInvitationToJoinNewOrg = (invitation) => () => {
        const viewModel = { invitation };
        openModal("OrgInvitationResposneModal", viewModel, getMyUserInvitations);
    };
    const orgInvitationResposneModal = getModal("OrgInvitationResposneModal");

    const respondToFarmOwnershipNomination = (nomination) => () => {
        const viewModel = { nomination };
        openModal("FarmOwnershipNominationResponseModal", viewModel, getMyFarmAccessInvitations);
    };
    const farmOwnershipNominationResponseModal = getModal("FarmOwnershipNominationResponseModal");

    const respondToRequestToAccessYourFarm = (accessRequest) => () => {
        const viewModel = { accessRequest };
        openModal("FarmAccessRequestResponseModal", viewModel, getMyFarmAccessRequests);
    };
    const farmAccessRequestResponseModal = getModal("FarmAccessRequestResponseModal");

    const respondToInvitationToJoinFarmGroup = (farmGroup) => () => {
        const viewModel = { farmGroup };
        openModal("FarmGroupInvitationResponseModal", viewModel);
    };
    const farmGroupInvitationModal = getModal("FarmGroupInvitationResponseModal");

    const resendRequestToAccessAFarm = (accessRequest) => (e) => {
        e.preventDefault();
        props.confirm(`Are you sure you want to resend your request to access,'${accessRequest.farmName}'?`, () => props.resendFarmAccessRequest(accessRequest));
    };

    return (
        <Page>
            <DashboardPageHead breadcrumb={[{ name: "Actions" }]} />
            <PageBody>
                <Panel title={`Action required (${myActions.actionCount})`} loading={online && loading} referrer={"/"}>
                    <PanelBody>
                        <div className="Table">
                            <table>
                                <thead>
                                    <tr>
                                        <th data-width="20">Action</th>
                                        <th data-width="20">Farm</th>
                                        <th data-width="10">Requested on</th>
                                        <th data-width="30">Details</th>
                                        {online && <th className="th--shrink">&nbsp;</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {myActions.invitationsToJoinNewOrgs.map((action, i) => {
                                        return (
                                            <tr key={i} className="hover">
                                                <td valign="top">{action.action}</td>
                                                <td valign="top">-</td>
                                                <td valign="top">{action.when}</td>
                                                <td valign="top">{action.details}</td>
                                                {online && (
                                                    <td valign="top">
                                                        <div className="u-flex">
                                                            <ActionLink id={`respond-to-invite-to-join-new-org-${action.payload.id}`} className="IconLink--edit" onClick={respondToInvitationToJoinNewOrg(action.payload)}>
                                                                Respond
                                                            </ActionLink>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                    {myActions.farmOwnershipNominations.map((action, i) => {
                                        return (
                                            <tr key={action.payload.id} className="hover">
                                                <td valign="top">{action.action}</td>
                                                <td valign="top" id={`farmname_${i}`}>
                                                    <h4 className="u-mt-0">{action.payload.farmName}</h4>
                                                    {action.payload.farmAddress}
                                                </td>
                                                <td valign="top">{action.when}</td>
                                                <td valign="top">{action.details}</td>
                                                {online && (
                                                    <td valign="top">
                                                        <div className="u-flex">
                                                            <ActionLink id={`respond-to-farm-ownership-nomination-${action.payload.id}`} className="IconLink--edit" onClick={respondToFarmOwnershipNomination(action.payload)}>
                                                                Respond
                                                            </ActionLink>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                    {myActions.requestsToAccessYourFarms.map((action, i) => {
                                        return (
                                            <tr key={i} className="hover">
                                                <td valign="top">{action.action}</td>
                                                <td valign="top" id={`farmname_${i}`}>
                                                    <h4 className="u-mt-0">{action.payload.farmName}</h4>
                                                    {action.payload.farmAddress}
                                                </td>
                                                <td valign="top">{action.when}</td>
                                                <td valign="top">{action.details}</td>
                                                {online && (
                                                    <td valign="top">
                                                        <div className="u-flex">
                                                            <ActionLink id={`respond-to-farm-access-request-${action.payload.id}`} className="IconLink--edit" onClick={respondToRequestToAccessYourFarm(action.payload)}>
                                                                Respond
                                                            </ActionLink>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                    {authContext.isSystemAdmin &&
                                        myActions.outstandingFarmAccessRequestsForSysAdmin.map((action, i) => {
                                            return (
                                                <tr key={i} className="hover">
                                                    <td valign="top">{action.action}</td>
                                                    <td valign="top" id={`farmname_${i}`}>
                                                        <h4 className="u-mt-0">{action.payload.farmName}</h4>
                                                        {action.payload.farmAddress}
                                                    </td>
                                                    <td valign="top">{action.when}</td>
                                                    <td valign="top">{action.details}</td>
                                                    {online && (
                                                        <td valign="top">
                                                            <div className="u-flex">
                                                                <ActionLink id={`respond-to-farm-access-request-${action.payload.id}`} className="IconLink--edit" onClick={respondToRequestToAccessYourFarm(action.payload)}>
                                                                    Respond
                                                                </ActionLink>
                                                                <ActionLink id={`resend-farm-access-request-${action.payload.id}`} className="IconLink--shield u-ml-sm" onClick={resendRequestToAccessAFarm(action.payload)}>
                                                                    Resend
                                                                </ActionLink>
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    {myActions.farmGroups.map((action, i) => {
                                        return (
                                            <tr key={i} className="hover">
                                                <td valign="top">{action.action}</td>
                                                <td valign="top" id={`farmname_${i}`}>
                                                    <h4 className="u-mt-0">{action.payload.farmName}</h4>
                                                    {action.payload.farmAddress}
                                                </td>
                                                <td valign="top">{action.when}</td>
                                                <td valign="top">{action.details}</td>
                                                {online && (
                                                    <td valign="top">
                                                        <div className="u-flex">
                                                            <ActionLink id={`respond-to-farm-group-invitation-${action.payload.id}`} className="IconLink--edit" onClick={respondToInvitationToJoinFarmGroup(action.payload)}>
                                                                Respond
                                                            </ActionLink>
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </PanelBody>
                </Panel>
                {farmAccessRequestResponseModal && <FarmAccessRequestResponseModal {...farmAccessRequestResponseModal.modalProps} />}
                {farmOwnershipNominationResponseModal && <FarmOwnershipNominationResponseModal {...farmOwnershipNominationResponseModal.modalProps} />}
                {orgInvitationResposneModal && <OrgInvitationResposneModal {...orgInvitationResposneModal.modalProps} />}
                {farmGroupInvitationModal && <FarmGroupInvitationResponseModal {...farmGroupInvitationModal.modalProps} />}
            </PageBody>
        </Page>
    );
};

export default compose(
    withAppContext,
    withState((state, ownProps) => {
        const { dashboard } = state;
        const { farm, authContext } = ownProps;

        const { myUserInvitations, myUserInvitationsLoading, myFarmAccessInvitations, myFarmAccessInvitationsLoading, myFarmAccessRequests, myFarmGroups, myFarmGroupInvitesLoading } = dashboard;

        const isStudent = authContext.accountType === "Student";

        const myActions = {
            invitationsToJoinNewOrgs: [],
            farmOwnershipNominations: [],
            requestsToAccessYourFarms: [],
            farmGroups: [],
            actionCount: 0,
        };
        myActions.invitationsToJoinNewOrgs =
            farm || isStudent
                ? []
                : (myUserInvitations || [])
                      .filter((invite) => invite.status === "Pending")
                      .map((invite) => {
                          myActions.actionCount++;
                          const details = (
                              <div>
                                  You are currently registered as a user in the <b>{authContext.accountName}</b> organisation. The <b>{invite.accountName}</b> organisation has invited you to leave your current organisation and join their organisation.
                                  <p className="u-textWarning">WARNING - IF YOU ACCEPT THIS INVITATION YOU WILL LOSE ACCESS TO ALL YOUR CURRENT FARM ACCOUNTS</p>
                              </div>
                          );
                          return {
                              action: "You've been asked to leave your current organisation and join a new organisation",
                              when: utils.dateLong(invite.invitedOn),
                              user: "",
                              org: invite.accountName,
                              payload: invite,
                              details,
                          };
                      });
        myActions.farmOwnershipNominations = (myFarmAccessInvitations || [])
            .filter((invite) => (!farm || farm.id === invite.farmId) && invite.status === "Pending")
            .map((invite) => {
                myActions.actionCount++;
                const details = (
                    <div>
                        <b>{invite.invitedBy.userFullName}</b> from the <b>{invite.invitedBy.accountName}</b> organisation has nominated you as an owner of the <b>{invite.farmName}</b> farm at <b>{invite.farmAddress}</b>
                    </div>
                );
                return {
                    action: "You've been nominated as an owner of a farm",
                    when: utils.dateLong(invite.invitedOn),
                    user: invite.invitedBy.userFullName,
                    org: invite.invitedBy.accountName,
                    payload: invite,
                    details,
                };
            });
        myActions.requestsToAccessYourFarms = (myFarmAccessRequests || [])
            .filter((request) => (!farm || farm.id === request.farmId) && request.status === "Pending" && authContext.userId && request.requestedBy.userId !== authContext.userId && !authContext.isSystemAdmin)
            .map((request) => {
                myActions.actionCount++;
                const details = (
                    <div>
                        <b>{request.requestedBy.userFullName}</b> from the <b>{request.requestedBy.accountName}</b> organisation has requested <b>{request.role}</b> access to <b>{request.farmName}</b> farm at <b>{request.farmAddress}</b>
                    </div>
                );
                return {
                    action: "Someone has requested access to your farm",
                    when: utils.dateLong(request.requestedOn),
                    user: request.requestedBy.userFullName,
                    org: request.requestedBy.accountName,
                    payload: request,
                    details,
                };
            });
        myActions.outstandingFarmAccessRequestsForSysAdmin = ((!farm && myFarmAccessRequests) || [])
            .filter((request) => request.status === "Pending" && request.requestedBy.userId !== authContext.userId && authContext.isSystemAdmin)
            .map((request) => {
                myActions.actionCount++;
                const isUnknown = request.emailStatus === "Unknown";
                const details = (
                    <div>
                        <b>{request.requestedBy.userFullName}</b> from the <b>{request.requestedBy.accountName}</b> organisation requested <b>{request.role}</b> access to the <b>{request.farmName}</b> farm at <b>{request.farmAddress}</b>
                        <p className={request.failed && !isUnknown ? "u-font-red u-font-600 hover" : "hover"}>Email status: {request.emailStatus}</p>
                    </div>
                );
                return {
                    action: "Outstanding farm access request",
                    when: utils.dateLong(request.requestedOn),
                    user: request.requestedBy.userFullName,
                    org: request.requestedBy.accountName,
                    payload: request,
                    details,
                };
            });
        myActions.farmGroups = (myFarmGroups || [])
            .filter((fg) => !fg.isMember && (farm == null || farm.id === fg.farmId))
            .map((invite) => {
                myActions.actionCount++;
                const details = (
                    <div>
                        <b>{invite.invitedByUser}</b> from the <b>{invite.invitedByAccount}</b> organisation has invited your <b>{invite.farmName}</b> farm at <b>{invite.farmAddress}</b> to join their <b>{invite.name}</b> farm collaboration group
                    </div>
                );
                return {
                    action: "A farm you own has been invited to join a farm group",
                    when: utils.dateLong(invite.invitedOn),
                    user: invite.invitedByUser,
                    org: invite.invitedByAccount,
                    payload: invite,
                    details,
                };
            });

        const loading = myUserInvitationsLoading || myFarmAccessInvitationsLoading || myFarmGroupInvitesLoading;

        return {
            loading,
            myActions,
        };
    }),
    withActions({
        getMyUserInvitations,
        getMyFarmAccessInvitations,
        getMyFarmAccessRequests,
        getMyFarmGroups,
        confirm,
        resendFarmAccessRequest,
    })
)(MyNotificationActions);
